import { render, staticRenderFns } from "./ImagePosition.vue?vue&type=template&id=0fa5f639&"
import script from "./ImagePosition.vue?vue&type=script&lang=js&"
export * from "./ImagePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports